module.exports = __webpack_public_path__ + "static/media/dots.1451539e.svg";